import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "row",
  id: "visit-page"
}
const _hoisted_3 = { class: "col-12 card" }
const _hoisted_4 = { class: "row mx-2 my-5" }
const _hoisted_5 = { class: "col-sm-12 col-md-4 order-md-last" }
const _hoisted_6 = { class: "text-center mx-auto mb-0 w-75" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { class: "text-center mb-4" }
const _hoisted_11 = { class: "text-secondary" }
const _hoisted_12 = { class: "text-primary" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "mb-0" }
const _hoisted_15 = { class: "text-muted" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "mb-0" }
const _hoisted_18 = { class: "text-muted" }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "mb-0" }
const _hoisted_22 = { class: "mb-0" }
const _hoisted_23 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_24 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_25 = { key: 2 }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 3 }
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "col-12" }
const _hoisted_30 = { key: 4 }
const _hoisted_31 = { class: "mb-4" }
const _hoisted_32 = ["value"]
const _hoisted_33 = { key: 5 }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "mb-4" }
const _hoisted_36 = ["value"]
const _hoisted_37 = { key: 6 }
const _hoisted_38 = { key: 7 }
const _hoisted_39 = {
  key: 0,
  class: "alert alert-danger mt-3"
}
const _hoisted_40 = { class: "row" }
const _hoisted_41 = { class: "col-12" }
const _hoisted_42 = { key: 8 }
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { key: 0 }
const _hoisted_45 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_46 = { key: 1 }
const _hoisted_47 = {
  key: 2,
  class: "mb-3"
}
const _hoisted_48 = {
  key: 3,
  class: "mb-3"
}
const _hoisted_49 = {
  key: 4,
  class: "d-inline"
}
const _hoisted_50 = {
  key: 5,
  class: "d-inline"
}
const _hoisted_51 = {
  key: 6,
  class: "d-inline"
}
const _hoisted_52 = {
  key: 7,
  class: "d-inline"
}
const _hoisted_53 = {
  key: 8,
  class: "d-inline"
}
const _hoisted_54 = {
  key: 9,
  class: "d-inline"
}
const _hoisted_55 = {
  key: 10,
  class: "d-inline"
}
const _hoisted_56 = {
  key: 11,
  class: "d-inline"
}
const _hoisted_57 = {
  key: 12,
  class: "my-2"
}
const _hoisted_58 = {
  key: 13,
  class: "text-danger mt-1"
}
const _hoisted_59 = { key: 9 }
const _hoisted_60 = { key: 0 }
const _hoisted_61 = { key: 0 }
const _hoisted_62 = { key: 1 }
const _hoisted_63 = { key: 1 }
const _hoisted_64 = {
  key: 1,
  class: "btn btn-secondary btn-md w-100 mb-2",
  disabled: ""
}
const _hoisted_65 = {
  key: 3,
  class: "btn btn-secondary btn-md w-100 mb-2",
  disabled: ""
}
const _hoisted_66 = ["href"]
const _hoisted_67 = { class: "col-sm-12 col-md-8" }
const _hoisted_68 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_visit_schedule_form = _resolveComponent("visit-schedule-form")!
  const _component_modal = _resolveComponent("modal")!
  const _component_schedule_form = _resolveComponent("schedule-form")!
  const _component_join_links = _resolveComponent("join-links")!
  const _component_scenario_card = _resolveComponent("scenario-card")!
  const _component_feedback_form = _resolveComponent("feedback-form")!
  const _component_participant_feedback = _resolveComponent("participant-feedback")!
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.loading && typeof(_ctx.visit) !== 'undefined')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (!_ctx.show_feedback_form && !_ctx.show_participant_feedback && !_ctx.view_participant_feedback)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("h4", _hoisted_6, [
                        (!_ctx.visit.is_complete && !_ctx.visit.is_canceled)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_7, "This visit is scheduled for:"))
                          : (_ctx.visit.is_canceled || _ctx.visit.no_show || _ctx.visit.learner_technical_issue)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_8, "This visit was scheduled for:"))
                            : (_ctx.visit.is_complete)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_9, "This visit occurred on:"))
                              : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("h4", _hoisted_10, [
                        _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.moment(_ctx.visit.utc_time || _ctx.visit.local_time).format('MM/DD/YY')), 1),
                        _cache[35] || (_cache[35] = _createTextVNode()),
                        _cache[36] || (_cache[36] = _createElementVNode("small", null, "at", -1)),
                        _cache[37] || (_cache[37] = _createTextVNode()),
                        _createElementVNode("span", _hoisted_12, [
                          _createTextVNode(_toDisplayString(_ctx.moment(_ctx.visit.utc_time || _ctx.visit.local_time).format('h:mm')), 1),
                          _createElementVNode("sup", null, _toDisplayString(_ctx.moment(_ctx.visit.utc_time || _ctx.visit.local_time).format('a')), 1)
                        ])
                      ]),
                      (_ctx.is_admin || _ctx.is_client_admin)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _createElementVNode("p", _hoisted_14, "Participant: " + _toDisplayString(_ctx.visit.learner.name), 1),
                            _createElementVNode("p", null, [
                              _createElementVNode("small", _hoisted_15, [
                                _createTextVNode(_toDisplayString(_ctx.visit.learner.email), 1),
                                _cache[38] || (_cache[38] = _createElementVNode("br", null, null, -1)),
                                _createTextVNode(_toDisplayString(_ctx.timezones.learner), 1)
                              ])
                            ]),
                            (_ctx.show_sp_data)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                  _createElementVNode("p", _hoisted_17, "Standardized Patient: " + _toDisplayString(_ctx.visit.standardized_patient.name), 1),
                                  _createElementVNode("p", null, [
                                    _createElementVNode("small", _hoisted_18, [
                                      _createTextVNode(_toDisplayString(_ctx.visit.standardized_patient.email), 1),
                                      _cache[39] || (_cache[39] = _createElementVNode("br", null, null, -1)),
                                      _createTextVNode(_toDisplayString(_ctx.timezones.sp), 1)
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.learner_type !== '')
                              ? (_openBlock(), _createElementBlock("p", _hoisted_19, "Learner Type: " + _toDisplayString(_ctx.learner_type), 1))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.is_sp)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                            _createElementVNode("p", _hoisted_21, "Participant: " + _toDisplayString(_ctx.visit.learner.name), 1),
                            _createElementVNode("p", _hoisted_22, [
                              (_ctx.visit.learner.profession !== null)
                                ? (_openBlock(), _createElementBlock("small", _hoisted_23, "Profession: " + _toDisplayString(_ctx.visit.learner.profession.title), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("p", null, [
                              (_ctx.visit.learner.specialty)
                                ? (_openBlock(), _createElementBlock("small", _hoisted_24, "Specialty: " + _toDisplayString(_ctx.visit.learner.specialty.title), 1))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.show_cancel)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            _cache[41] || (_cache[41] = _createElementVNode("p", null, "Are you sure you want to cancel the visit?", -1)),
                            (_ctx.visit.scenario.fee >0)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_26, _cache[40] || (_cache[40] = [
                                  _createElementVNode("strong", null, "Refunds will not be issued for a canceled visit. If you submit another visit request after cancelation, you will be required to pay the full fee again.", -1)
                                ])))
                              : _createCommentVNode("", true),
                            _createElementVNode("button", {
                              class: "btn btn-lg btn-secondary w-100 mb-2",
                              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
                            }, "Cancel Visit"),
                            _createElementVNode("button", {
                              class: "btn btn-lg btn-secondary w-100 mb-2",
                              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showCancelConfirm && _ctx.showCancelConfirm(...args)))
                            }, "Return to Visit Overview")
                          ]))
                        : (_ctx.show_reschedule)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                              _cache[44] || (_cache[44] = _createElementVNode("p", null, "Select convenient times for your SP visit", -1)),
                              _createVNode(_component_visit_schedule_form, {
                                field: "visit_date_one",
                                "alt-field": "visit_date_two",
                                "start-date": _ctx.start_date,
                                "end-date": _ctx.end_date,
                                "disabled-dates": _ctx.partner_disabled_dates,
                                onUpdateDate: _ctx.setDate,
                                "scenario-id": _ctx.visit.scenario_id
                              }, null, 8, ["start-date", "end-date", "disabled-dates", "onUpdateDate", "scenario-id"]),
                              _createElementVNode("div", _hoisted_28, [
                                _createElementVNode("div", _hoisted_29, [
                                  _createElementVNode("button", {
                                    class: "btn btn-lg btn-secondary w-100 mb-2",
                                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showRescheduleModal && _ctx.showRescheduleModal(...args)))
                                  }, "Reschedule Visit"),
                                  _createElementVNode("button", {
                                    class: "btn btn-lg btn-secondary w-100 mb-2",
                                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showReschedule && _ctx.showReschedule(...args)))
                                  }, "Return to Visit Overview")
                                ])
                              ]),
                              _createVNode(_component_modal, {
                                modelValue: _ctx.reschedule_modal,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.reschedule_modal) = $event))
                              }, {
                                header: _withCtx(() => _cache[42] || (_cache[42] = [
                                  _createTextVNode("Reschedule Visit")
                                ])),
                                default: _withCtx(() => [
                                  _cache[43] || (_cache[43] = _createElementVNode("p", null, "Are you sure you want to reschedule this visit?", -1)),
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-lg btn-primary w-100 mb-2",
                                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.rescheduleVisit && _ctx.rescheduleVisit(...args)))
                                  }, "Reschedule Visit")
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]))
                          : (_ctx.show_transfer_form)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                _cache[45] || (_cache[45] = _createElementVNode("p", null, "Select standardized patient to transfer visit to.", -1)),
                                _createElementVNode("div", _hoisted_31, [
                                  _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.transferForm.sp_id.value) = $event))
                                  }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sp_users, (sp) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: sp.id,
                                        value: sp.id
                                      }, _toDisplayString(sp.first_name) + " " + _toDisplayString(sp.last_name), 9, _hoisted_32))
                                    }), 128))
                                  ], 512), [
                                    [_vModelSelect, _ctx.transferForm.sp_id.value]
                                  ])
                                ]),
                                _createElementVNode("button", {
                                  class: "btn btn-secondary btn-md w-100 mb-2",
                                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.transfer && _ctx.transfer(...args)))
                                }, "Transfer Visit"),
                                _createElementVNode("button", {
                                  class: "btn btn-secondary btn-md w-100 mb-2",
                                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.showTransferForm && _ctx.showTransferForm(...args)))
                                }, "Cancel")
                              ]))
                            : (_ctx.show_observers)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                  _cache[48] || (_cache[48] = _createElementVNode("p", null, "Observers", -1)),
                                  _createElementVNode("ul", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visit.observer_users, (observer) => {
                                      return (_openBlock(), _createElementBlock("li", {
                                        key: observer.id
                                      }, [
                                        _createElementVNode("div", null, [
                                          _createTextVNode(_toDisplayString(observer.user.name), 1),
                                          _cache[46] || (_cache[46] = _createElementVNode("br", null, null, -1)),
                                          _createElementVNode("small", null, _toDisplayString(observer.user.email), 1)
                                        ]),
                                        _cache[47] || (_cache[47] = _createTextVNode()),
                                        _createElementVNode("button", {
                                          class: "btn btn-secondary btn-xs mb-4",
                                          onClick: ($event: any) => (_ctx.removeObserver(observer.user.id))
                                        }, "Remove", 8, _hoisted_34)
                                      ]))
                                    }), 128))
                                  ]),
                                  _cache[49] || (_cache[49] = _createElementVNode("p", null, "Add Observer", -1)),
                                  _createElementVNode("div", _hoisted_35, [
                                    _withDirectives(_createElementVNode("select", {
                                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.observerForm.add_observer_id.value) = $event))
                                    }, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.observer_users, (observer) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                          key: observer.id,
                                          value: observer.id
                                        }, _toDisplayString(observer.first_name) + " " + _toDisplayString(observer.last_name), 9, _hoisted_36))
                                      }), 128))
                                    ], 512), [
                                      [_vModelSelect, _ctx.observerForm.add_observer_id.value]
                                    ])
                                  ]),
                                  _createElementVNode("button", {
                                    class: "btn btn-secondary btn-md w-100 mb-2",
                                    onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.addObserver && _ctx.addObserver(...args)))
                                  }, "Add"),
                                  _createElementVNode("button", {
                                    class: "btn btn-secondary btn-md w-100 mb-2",
                                    onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.showObservers && _ctx.showObservers(...args)))
                                  }, "Return to Visit")
                                ]))
                              : (_ctx.show_reinstate)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                    _cache[50] || (_cache[50] = _createElementVNode("p", null, "Are you sure you want to reinstate this visit? Visit will be marked as confirmed.", -1)),
                                    _createElementVNode("button", {
                                      class: "btn btn-lg btn-secondary w-100 mb-2",
                                      onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.reinstate && _ctx.reinstate(...args)))
                                    }, "Reinstate Visit"),
                                    _createElementVNode("button", {
                                      class: "btn btn-lg btn-secondary w-100 mb-2",
                                      onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.showReinstateConfirm && _ctx.showReinstateConfirm(...args)))
                                    }, "Return to Visit Overview")
                                  ]))
                                : (_ctx.show_admin_reschedule)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                      _cache[54] || (_cache[54] = _createElementVNode("p", { class: "mb-0" }, "Adjust Date and Time", -1)),
                                      _cache[55] || (_cache[55] = _createElementVNode("p", null, [
                                        _createElementVNode("small", null, "Visit will be scheduled in participant's time zone")
                                      ], -1)),
                                      _createVNode(_component_schedule_form, {
                                        is_single: true,
                                        field: "admin_date",
                                        "alt-field": "none",
                                        "start-date": _ctx.admin_start_date,
                                        onUpdateDate: _ctx.setAdminStartDate
                                      }, null, 8, ["start-date", "onUpdateDate"]),
                                      (_ctx.has_admin_date_error)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(_ctx.admin_date_error), 1))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("p", null, [
                                        _createElementVNode("label", null, [
                                          _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.admin_is_confirmed) = $event)),
                                            type: "checkbox"
                                          }, null, 512), [
                                            [_vModelCheckbox, _ctx.admin_is_confirmed]
                                          ]),
                                          _cache[51] || (_cache[51] = _createTextVNode(" Mark Visit as Confirmed"))
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_40, [
                                        _createElementVNode("div", _hoisted_41, [
                                          _createElementVNode("button", {
                                            class: "btn btn-lg btn-secondary w-100 mb-2",
                                            onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.showAdminReschuleModal && _ctx.showAdminReschuleModal(...args)))
                                          }, "Adjust Date and Time"),
                                          _createElementVNode("button", {
                                            class: "btn btn-lg btn-secondary w-100 mb-2",
                                            onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.toggleShowAdminReschedule && _ctx.toggleShowAdminReschedule(...args)))
                                          }, "Return to Vist Overview")
                                        ])
                                      ]),
                                      _createVNode(_component_modal, {
                                        modelValue: _ctx.show_admin_reschedule_modal,
                                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.show_admin_reschedule_modal) = $event))
                                      }, {
                                        header: _withCtx(() => _cache[52] || (_cache[52] = [
                                          _createTextVNode("Adjust Date and Time")
                                        ])),
                                        default: _withCtx(() => [
                                          _cache[53] || (_cache[53] = _createElementVNode("p", null, "Are you sure you want to adjust the date and time of this visit?", -1)),
                                          _createElementVNode("button", {
                                            type: "button",
                                            class: "btn btn-lg btn-primary w-100 mb-2",
                                            onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.saveAdminAdjustDate && _ctx.saveAdminAdjustDate(...args)))
                                          }, "Adjust Date and Time")
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"])
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                      (!_ctx.is_learner && !_ctx.visit.is_complete)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_43, [
                                            _cache[56] || (_cache[56] = _createTextVNode("This visit has ")),
                                            (_ctx.visit.is_confirmed)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_44, "been confirmed"))
                                              : _createCommentVNode("", true),
                                            (!_ctx.visit.is_confirmed)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_45, "not been confirmed"))
                                              : _createCommentVNode("", true),
                                            _cache[57] || (_cache[57] = _createTextVNode("."))
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_ctx.is_learner)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_46, "This visit has been scheduled"))
                                        : _createCommentVNode("", true),
                                      (_ctx.is_learner && !_ctx.visit.is_confirmed && !_ctx.visit.is_canceled)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_47, _cache[58] || (_cache[58] = [
                                            _createElementVNode("p", null, [
                                              _createElementVNode("small", null, [
                                                _createElementVNode("i", null, "You will be required to confirm your participation via SMS text message three days prior to the date of the visit. PLEASE NOTE: Unconfirmed visits will be canceled 21 hours prior to start time.")
                                              ])
                                            ], -1)
                                          ])))
                                        : _createCommentVNode("", true),
                                      (_ctx.is_learner && !_ctx.visit.is_confirmed && !_ctx.visit.is_canceled && _ctx.can_confirm)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                            _createElementVNode("button", {
                                              class: "btn btn-secondary btn-md w-100 mb-2",
                                              onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)))
                                            }, "Confirm Visit")
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_ctx.is_admin)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                            _createElementVNode("button", {
                                              class: "btn btn-secondary btn-md w-100 mb-2",
                                              onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.toggleShowAdminReschedule && _ctx.toggleShowAdminReschedule(...args)))
                                            }, "Adjust Date & Time")
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_ctx.is_super_admin && _ctx.visit.is_canceled && _ctx.can_reinstate)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                            _createElementVNode("button", {
                                              class: "btn btn-secondary btn-md w-100 mb-2",
                                              onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.showReinstateConfirm && _ctx.showReinstateConfirm(...args)))
                                            }, "Reinstate Visit")
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_ctx.is_sp || _ctx.is_learner)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                            _createVNode(_component_join_links, {
                                              class: "d-inline",
                                              joinevent: _ctx.visit,
                                              label: 'Visit',
                                              user: _ctx.user,
                                              onShowFeedbackForm: _ctx.showFeedbackForm
                                            }, null, 8, ["joinevent", "user", "onShowFeedbackForm"])
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_ctx.is_learner && _ctx.visit.is_complete == 0 && _ctx.visit.is_canceled == 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                            (_ctx.visit.scenario.fee == 0)
                                              ? (_openBlock(), _createElementBlock("button", {
                                                  key: 0,
                                                  class: "btn btn-secondary btn-md w-100 mb-2",
                                                  onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.showReschedule && _ctx.showReschedule(...args)))
                                                }, "Reschedule"))
                                              : _createCommentVNode("", true),
                                            (_ctx.visit.learner_technical_issue == 0)
                                              ? (_openBlock(), _createElementBlock("button", {
                                                  key: 1,
                                                  class: "btn btn-secondary btn-md w-100 mb-2",
                                                  onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.showCancelConfirm && _ctx.showCancelConfirm(...args)))
                                                }, "Cancel"))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_ctx.is_sp && _ctx.visit.is_complete == 0 && _ctx.visit.learner_technical_issue == 0 && _ctx.visit.is_canceled == 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                            _createElementVNode("button", {
                                              class: "btn btn-secondary btn-md w-100 mb-2",
                                              onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.shareScenario && _ctx.shareScenario(...args)))
                                            }, "Share Learner Information")
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_ctx.is_sp && _ctx.visit.is_complete == 0 && _ctx.visit.learner_technical_issue == 0 && _ctx.visit.is_canceled == 0 && _ctx.visit.scenario.is_feedback_form_enabled)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                            _createElementVNode("button", {
                                              class: "btn btn-secondary btn-md w-100 mb-2",
                                              onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.shareZoomMessage && _ctx.shareZoomMessage(...args)))
                                            }, "Share Stay On Zoom Message")
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_ctx.is_sp && _ctx.has_verbal_feedback)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                            _createElementVNode("button", {
                                              class: "btn btn-secondary btn-md w-100 mb-2",
                                              onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.printFeedback && _ctx.printFeedback(...args)))
                                            }, "Print Verbal Feedback")
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_ctx.can_transfer || _ctx.can_generate_reschedule || _ctx.can_edit_observers)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                            (_ctx.can_transfer && _ctx.visit.is_complete == 0 && _ctx.visit.learner_technical_issue == 0)
                                              ? (_openBlock(), _createElementBlock("button", {
                                                  key: 0,
                                                  class: "btn btn-secondary btn-md w-100 mb-2",
                                                  onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.getTransferUsers && _ctx.getTransferUsers(...args)))
                                                }, "Transfer Visit"))
                                              : _createCommentVNode("", true),
                                            (_ctx.can_generate_reschedule)
                                              ? (_openBlock(), _createElementBlock("button", {
                                                  key: 1,
                                                  class: "btn btn-secondary btn-md w-100 mb-2",
                                                  onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.generateReschedule && _ctx.generateReschedule(...args)))
                                                }, "Generate Reschedule Link"))
                                              : _createCommentVNode("", true),
                                            (_ctx.can_edit_observers)
                                              ? (_openBlock(), _createElementBlock("button", {
                                                  key: 2,
                                                  class: "btn btn-secondary btn-md w-100 mb-2",
                                                  onClick: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.getObserverUsers && _ctx.getObserverUsers(...args)))
                                                }, "Manage Observers"))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_ctx.reschedule_link != null)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_57, _toDisplayString(_ctx.reschedule_link), 1))
                                        : _createCommentVNode("", true),
                                      ((_ctx.is_sp || _ctx.is_learner) && _ctx.visit.is_complete == 0 && _ctx.visit.learner_technical_issue == 0 && _ctx.visit.is_canceled == 0)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_58, _cache[59] || (_cache[59] = [
                                            _createElementVNode("strong", null, "If join link does not open try disabling browser's popup blocker", -1)
                                          ])))
                                        : _createCommentVNode("", true)
                                    ])),
                      (_ctx.visit.is_complete && !_ctx.visit.no_show)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                            (_ctx.is_observer)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                                  _createElementVNode("button", {
                                    class: "btn btn-secondary btn-md w-100 mb-2",
                                    onClick: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.scorecard && _ctx.scorecard(...args)))
                                  }, [
                                    (!_ctx.is_observer_scorecard_complete)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_61, "Complete"))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_62, "View")),
                                    _cache[60] || (_cache[60] = _createTextVNode(" Scorecard"))
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.is_learner || _ctx.is_client_admin)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                  (_ctx.visit.is_scorecard_complete || _ctx.visit.is_feedback_form_complete)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        class: "btn btn-secondary btn-md w-100 mb-2",
                                        onClick: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_ctx.scorecard && _ctx.scorecard(...args)))
                                      }, "View Scorecard"))
                                    : ((_ctx.visit.scenario.is_scorecard_enabled || _ctx.visit.scenario.is_feedback_form_enabled) && (!_ctx.visit.is_scorecard_complete && !_ctx.visit.is_feedback_form_complete))
                                      ? (_openBlock(), _createElementBlock("button", _hoisted_64, "Scorecard Pending"))
                                      : _createCommentVNode("", true),
                                  (_ctx.is_client_admin && _ctx.visit.scenario.is_participant_feedback_enabled && _ctx.visit.is_participant_feedback_complete)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 2,
                                        class: "btn btn-secondary btn-md w-100 mb-2",
                                        onClick: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_ctx.viewParticipantFeedback && _ctx.viewParticipantFeedback(...args)))
                                      }, "View Participant Feedback"))
                                    : (_ctx.is_client_admin && _ctx.visit.scenario.is_participant_feedback_enabled && !_ctx.visit.is_participant_feedback_complete)
                                      ? (_openBlock(), _createElementBlock("button", _hoisted_65, "Participant Feedback Pending"))
                                      : _createCommentVNode("", true),
                                  (_ctx.has_recording)
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 4,
                                        class: "btn btn-secondary btn-md w-100 mb-2",
                                        href: _ctx.recording_url,
                                        target: "_blank"
                                      }, "View Recording", 8, _hoisted_66))
                                    : (_openBlock(), _createElementBlock("button", {
                                        key: 5,
                                        class: "btn btn-secondary btn-md w-100 mb-2",
                                        onClick: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => (_ctx.recordingError && _ctx.recordingError(...args)))
                                      }, "View Recording")),
                                  (_ctx.is_learner && _ctx.is_participant_feedback_available)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 6,
                                        class: "btn btn-secondary btn-md w-100 mb-2",
                                        onClick: _cache[34] || (_cache[34] = 
//@ts-ignore
(...args) => (_ctx.showParticipantFeedback && _ctx.showParticipantFeedback(...args)))
                                      }, "Provide Feedback"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_67, [
                      _createVNode(_component_scenario_card, {
                        scenario: _ctx.visit.scenario,
                        formatted_field_data: _ctx.formatted_field_data,
                        is_learner: _ctx.is_learner,
                        sp: _ctx.visit.standardized_patient
                      }, null, 8, ["scenario", "formatted_field_data", "is_learner", "sp"])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.show_feedback_form)
            ? (_openBlock(), _createBlock(_component_feedback_form, {
                key: 1,
                visit: _ctx.visit,
                onFeedbackFormCompleted: _ctx.feedbackFormCompleted,
                onReturnToVisit: _ctx.showFeedbackForm
              }, null, 8, ["visit", "onFeedbackFormCompleted", "onReturnToVisit"]))
            : _createCommentVNode("", true),
          (_ctx.show_participant_feedback)
            ? (_openBlock(), _createBlock(_component_participant_feedback, {
                key: 2,
                visit: _ctx.visit,
                view: "form",
                onParticipantFeedbackCompleted: _ctx.participantFeedbackCompleted,
                onReturnToVisit: _ctx.showParticipantFeedback
              }, null, 8, ["visit", "onParticipantFeedbackCompleted", "onReturnToVisit"]))
            : _createCommentVNode("", true),
          (_ctx.view_participant_feedback)
            ? (_openBlock(), _createBlock(_component_participant_feedback, {
                key: 3,
                visit: _ctx.visit,
                view: "observe",
                onReturnToVisit: _ctx.viewParticipantFeedback
              }, null, 8, ["visit", "onReturnToVisit"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.loading && typeof(_ctx.visit) === 'undefined')
      ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
          _cache[61] || (_cache[61] = _createElementVNode("h4", null, "Error Loading Visit", -1)),
          _createElementVNode("p", null, _toDisplayString(_ctx.loadErrorMessage), 1)
        ]))
      : _createCommentVNode("", true),
    _cache[62] || (_cache[62] = _createElementVNode("br", null, null, -1)),
    _createVNode(_component_loading, {
      active: _ctx.loading,
      "is-full-page": true
    }, null, 8, ["active"])
  ], 64))
}